import React from 'react';

interface IScrollTargetProps {
  id: string;
}

export const ScrollTarget: React.FC<IScrollTargetProps> = ({ id }) => (
  <label
    htmlFor={id}
    style={{
      position: 'absolute',
      height: '1px',
      width: '1px',
      overflow: 'hidden',
      clip: 'rect(1px, 1px, 1px, 1px)',
      whiteSpace: 'nowrap',
    }}
  />
);
